import { useQuery } from 'react-query';
import { queryGuestReservations } from 'api/guestReservation';
var useGuestReservations = function (_a, options) {
    var mapId = _a.mapId, spaceId = _a.spaceId, date = _a.date;
    return useQuery(['getGuestReservations', { mapId: mapId, spaceId: spaceId, date: date }], queryGuestReservations, options);
};
export default useGuestReservations;
